import { createSlice } from '@reduxjs/toolkit'

export interface Toast {
    title: string
    message: string
    onActionClick?: () => void
    actionTitle?: string
    timeout?: number
    id: string
    severity: 'error' | 'info' | 'success' | 'warning'
    // unable to navigate directly from gql error link because of circular dependency - had to pass the navigate path to the toast
    navigate?: string
}

interface ToastState {
    toasts: Toast[]
}

export const toastSlice = createSlice({
    name: 'toast',
    initialState: { toasts: [] } satisfies ToastState as ToastState,
    reducers: {
        addToast: (state, action) => {
            state.toasts = [
                ...state.toasts,
                {
                    ...action.payload,
                    id: action.payload.id || new Date().toISOString(),
                },
            ]
        },
        removeToast: (state, action) => {
            state.toasts = state.toasts.filter(
                (toast) => toast.id !== action.payload
            )
        },
    },
    selectors: { selectToasts: (state) => state.toasts },
})

export const { addToast, removeToast } = toastSlice.actions
export const { selectToasts } = toastSlice.selectors

export default toastSlice.reducer
